import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem
} from "@mui/material";

import { ref, push } from "firebase/database";
import { db } from "../firebase";

const EFC_SUBJECTS = [
  "Engineering Mathematics",
  "Engineering Physics",
  "Engineering Chemistry",
  "Basic Electrical Engineering",
  "Engineering Mechanics",
  "Programming",
  "Engineering Graphics"
];

function AdminPanel() {

  const [section, setSection] = useState("");
  const [subject, setSubject] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [startTime, setStartTime] = useState("");

  // -----------------------------
  // UPLOAD VIDEO (FIREBASE)
  // -----------------------------

  const handleUpload = async () => {

    if (!section || !title || !url) {
      alert("Please fill all required fields");
      return;
    }

    let liveTimestamp = null;

    // LIVE SECTION (LECTURES)
    if (section === "lectures") {

      if (!startTime) {
        alert("Enter live start time");
        return;
      }

      liveTimestamp = new Date(startTime).getTime();
    }

    const videoObj = {
      title: title,
      videoUrl: url,
      thumbnailUrl: thumbnail || "",
      liveStartTime: liveTimestamp
    };

    try {

      await push(ref(db, `videos/${section}`), videoObj);

      alert("Video Uploaded Successfully ✅");

      // RESET FORM

      setSection("");
      setSubject("");
      setTitle("");
      setUrl("");
      setThumbnail("");
      setStartTime("");

    } catch (error) {
      console.error(error);
      alert("Upload Failed ❌");
    }
  };

  return (

    <Box sx={{ maxWidth: 450, mx: "auto", mt: 4 }}>

      <Typography variant="h5" fontWeight="bold" mb={2}>
        Admin Video Upload Panel
      </Typography>

      {/* SECTION */}

      <TextField
        select
        fullWidth
        label="Section"
        value={section}
        onChange={(e) => setSection(e.target.value)}
        margin="normal"
      >
        <MenuItem value="efc">EFC</MenuItem>
        <MenuItem value="counselling">Counselling</MenuItem>
        <MenuItem value="lectures">Lectures (Live)</MenuItem>
      </TextField>

      {/* SUBJECT */}

      {section === "efc" && (

        <TextField
          select
          fullWidth
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
        >
          {EFC_SUBJECTS.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </TextField>

      )}

      {/* TITLE */}

      <TextField
        fullWidth
        label="Video Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        margin="normal"
      />

      {/* VIDEO URL */}

      <TextField
        fullWidth
        label="YouTube / Vimeo URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        margin="normal"
      />

      {/* THUMBNAIL URL */}

      <TextField
        fullWidth
        label="Thumbnail URL"
        value={thumbnail}
        onChange={(e) => setThumbnail(e.target.value)}
        margin="normal"
      />

      {/* LIVE TIME */}

      {section === "lectures" && (

        <TextField
          fullWidth
          type="datetime-local"
          label="Live Start Time"
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
        />

      )}

      {/* UPLOAD BUTTON */}

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleUpload}
      >
        Upload Video
      </Button>

    </Box>
  );
}

export default AdminPanel;
